import React from "react";

const MarketExplorerContainer = function ({
    title, subTitle, children, className, onClick, search
}) {
    const onClickHandle = onClick || (() => {});
    return (
        <div
            onClick={onClickHandle}
            className={`reportBuilderMarketExplorerContainer ${className}`}
        >
            {title && <p className="panel-title">{title}</p>}
            {subTitle && <p className="panel-subtitle">{subTitle}</p>}
            {search && <div className="panel-search">{search}</div>}
            <div className="panel-body">{children}</div>
        </div>
    );
};

export default MarketExplorerContainer;
